var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVersionControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M7 12h7.5a3.5 3.5 0 0 0 3.47-3.04 3.5 3.5 0 1 1 1.006.008A4.5 4.5 0 0 1 14.5 13H7v2.035a3.5 3.5 0 1 1-1 0v-6.07a3.5 3.5 0 1 1 1 0zm-3 6.5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0zm0-13a2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-5 0zM18.5 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z",
    opacity: 1,
    "data-original": "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersionControl);
export default __webpack_public_path__ + "static/media/version-control.09573bfc75ed0c82c61165de52615289.svg";
export { ForwardRef as ReactComponent };